import React from "react";
import { Bell, MapPin, User, Tag, ArrowRight } from "lucide-react";

export default function OrderAlertModal({ order, onClose, onView }) {
  if (!order) return null;

  return (
    <div className="modal-overlay">
      <div className="order-alert-card">
        <div className="alert-header">
          <div className="icon-container">
            <Bell className="bell-icon" size={32} />
            <span className="ping"></span>
          </div>
          <h2>Nouvelle commande reçue</h2>
          <p className="subtitle">Une action immédiate est requise</p>
        </div>


        <div className="alert-body">
          <div className="price-tag">{order.amount?.toLocaleString()} CFA</div>
          <div className="info-row">
            <User size={16} className="text-muted" />
            <div>
              <span className="label">Client</span>
              <p className="value">
                {order.customer?.user?.firstName}{" "}
                {order.customer?.user?.lastName}
              </p>
            </div>
          </div>

          <div className="info-row">
            <Tag size={16} className="text-muted" />
            <div>
              <span className="label">Type de commande</span>
              <p className="value">
                {order.order_type?.name || "Introuvable"}
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="alert-actions">
          <button className="btn-secondary" onClick={onClose}>
            Ignorer
          </button>
          <button
            className="btn-primary"
            onClick={() => {
              onView(order);
              onClose();
            }}
          >
            Voir la commande <ArrowRight size={18} />
          </button>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.8); /* Fond plus sombre type ardoise */
          backdrop-filter: blur(12px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: fadeIn 0.3s ease-out;
        }

        .order-alert-card {
          background: white;
          padding: 2.5rem;
          border-radius: 28px;
          width: 95%;
          max-width: 420px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
          animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          border: 1px solid #f1f5f9;
        }

        .alert-header {
          text-align: center;
          margin-bottom: 1rem;
        }

        .icon-container {
          position: relative;
          width: 64px;
          height: 64px;
          background: #fff7ed;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: #e67e22;
        }

        .bell-icon {
          animation: ring 2s ease infinite;
        }

        .ping {
          position: absolute;
          top: 0;
          right: 0;
          height: 12px;
          width: 12px;
          background: #ef4444;
          border-radius: 50%;
          border: 2px solid white;
        }

        h2 {
          font-size: 1.5rem;
          font-weight: 800;
          color: #0f172a;
          margin: 0;
        }

        .subtitle {
          color: #64748b;
          font-size: 0.9rem;
        
        }

        .alert-body {
          background: #f8fafc;
          border-radius: 20px;
          padding: 1.5rem;
          margin-bottom: 2rem;
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
        }

        .info-row {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .label {
          display: block;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #94a3b8;
          font-weight: 600;
        }

        .value {
          margin: 0;
          color: #334155;
          font-weight: 600;
          font-size: 1rem;
        }

        .truncate {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 250px;
        }

        .price-tag {
         
          border-bottom: 1px solid #e2e8f0;
          text-align: center;
          font-size: 1.5rem;
          font-weight: 800;
          color: #e67e22;
        }

        .alert-actions {
          display: flex;
          gap: 1rem;
        }

        .btn-primary {
          flex: 2;
          background: #e67e22;
          color: white;
          border: none;
          padding: 1rem;
          border-radius: 14px;
          cursor: pointer;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.2s;
        }

        .btn-primary:hover {
          background: #b55d10;
          transform: translateY(-2px);
        }

        .btn-secondary {
          flex: 1;
          background: #f1f5f9;
          color: #64748b;
          border: none;
          padding: 1rem;
          border-radius: 14px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.2s;
        }

        .btn-secondary:hover {
          background: #e2e8f0;
          color: #0f172a;
        }

        @keyframes ring {
          0%,
          100% {
            transform: rotate(0);
          }
          10%,
          30%,
          50%,
          70% {
            transform: rotate(10deg);
          }
          20%,
          40%,
          60%,
          80% {
            transform: rotate(-10deg);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
